import cn from 'classnames';
import Link from 'next/link';

import Loading from 'react-scale/components/elements/loading';
import ScaleLogo from 'react-scale/components/tailwind/ScaleLogo';
import { useToggleState } from 'react-scale/hooks/use-toggle-state';
import { useEffect } from 'react';
import Button from 'react-scale/components/elements/button';
import MobileMenu from './mobile-menu';

const leftSideLinks = [
  {
    href: '/events/transformx/speakers',
    label: 'Speakers'
  },
  {
    href: '/events/transformx/agenda',
    label: 'Agenda'
  }
];

const inPersonLinks = [
  { href: '#speakers', label: 'Speakers' },
  { href: '#agenda', label: 'Agenda' },
  { href: '#faq', label: 'FAQ' }
];

const Header = ({ className, cta = null, disabled = false }) => {
  const mobileMenuState = useToggleState();

  useEffect(() => {
    if (mobileMenuState.isOn) {
      document.body.style.setProperty('overflow', 'hidden');
    } else {
      document.body.style.removeProperty('overflow');
    }

    return () => {
      document.body.style.removeProperty('overflow');
    };
  }, [mobileMenuState.isOn]);

  return (
    <header
      className={cn(
        'z-40 sticky top-0 transition',
        {
          'bg-black/60 backdrop-filter backdrop-blur-sm backdrop-saturate-150':
            !mobileMenuState.isOn,
          'bg-black/100': mobileMenuState.isOn
        },
        className
      )}
    >
      <Loading />
      <div className="container">
        <div
          className={cn('flex items-center justify-between h-full lg:hidden', { 'h-16': disabled })}
        >
          <HeaderLogo disabled />
          {!disabled && <MobileMenu {...mobileMenuState} />}
        </div>

        {disabled && (
          <div className="relative z-30 grid-cols-3 pb-4 lg:py-4 lg:grid">
            <div className="hidden lg:block">
              <HeaderLogo disabled />
            </div>
            <nav className="relative flex items-center w-full lg:justify-center">
              <ul className="flex space-x-8">
                {inPersonLinks.map(({ href, label }) => (
                  <li key={`link-${label}`}>
                    <Link href={href} className="text-sm font-medium">
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        )}

        {!disabled && (
          <>
            <div className="relative z-30 hidden grid-cols-3 py-4 lg:grid">
              <HeaderLogo disabled={disabled} />
              <nav className="relative flex items-center justify-center w-full">
                <ul className="flex space-x-8">
                  {leftSideLinks.map(({ href, label }) => (
                    <li key={`link-${label}`}>
                      <Link href={href} className="text-sm font-medium">
                        {label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </nav>
              <div className="flex justify-end">
                <div className="w-fit">
                  {cta ?? (
                    <Button
                      text="Watch On-Demand"
                      type="primary"
                      size="small"
                      href="https://exchange.scale.com/home/tags/TransformX-2022-6352c8272ccd95d20b647e91"
                      target="_blank"
                    />
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </header>
  );
};

const HeaderLogo = ({ disabled = false }) => (
  <>
    {!disabled && (
      <Link href="/events/transformx">
        <div className="flex items-center space-x-2">
          <span className="h-[21px] sm:h-[18px] mt-[-2px]">
            <ScaleLogo className={cn('w-auto h-full fill-current text-white')} />
          </span>
          <p className="text-[28px] font-aeonik sm:text-2xl text-transform-x-gradient">
            TransformX
          </p>
        </div>
      </Link>
    )}

    {disabled && (
      <div className="flex items-center space-x-2">
        <span className="h-[21px] sm:h-[18px] mt-[-2px]">
          <ScaleLogo className={cn('w-auto h-full fill-current text-white')} />
        </span>
        <p className="text-[28px] font-aeonik sm:text-2xl text-transform-x-gradient">TransformX</p>
      </div>
    )}
  </>
);

// const MenuMobile = ({ onClick, color }) => (
//   <div className="flex items-center cursor-pointer lg:hidden" onClick={onClick}>
//     <svg className={cn('w-6 h-auto fill-current', color)} viewBox="0 0 24 12">
//       <rect width="24" height="2" />
//       <rect y="5" width="24" height="2" />
//       <rect y="10" width="24" height="2" />
//     </svg>
//   </div>
// );

export default Header;
